query AssistantConversationShow($id: ID!) {
  assistantConversation(id: $id) {
    id
    audience
    title
    topic
    messageCount
    utm {
      source
      medium
      campaign
      content
      term
      link {
        id
        title
        deleted
      }
      email {
        kind
        automationId
        automationName
        nodeId
        template
      }
      capturedAt
      backfilled
    }
    lastMessageAt
    createdAt
    hasRequest
    origin
    originErrorCode
    knowledgeGap
    knowledgeGapQuestions
    likes
    dislikes
    inputTokens
    outputTokens
    cacheReadTokens
    cacheWriteTokens
    costUsd
    model
    user {
      id
      email
      displayName
    }
    platform {
      id
      title
    }
    organization {
      id
      title
    }
    messages {
      id
      role
      kind
      text
      rating
      content
      costUsd
      durationMs
      error
      pageUrl
      page
      cards
      attachments {
        id
        url
        width
        height
      }
      plan {
        id
        status
        title
      }
      createdAt
    }
  }
}
